import styled from 'styled-components';
import { Text } from 'view/atoms';
import { Colors, Media, FooterSizes } from 'enums';

export const FooterStyled = styled.footer`
  box-sizing: border-box;
  z-index: 3;
  background-color: ${Colors.gray1};
  height: ${FooterSizes.mobile.height};
  width: 100%;
  padding: 30px 20px 14px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 0 0 auto;

  @media ${Media.tablet} {
    padding: 30px 40px 14px 40px;
    height: ${FooterSizes.tablet.height};
  }

  @media ${Media.notebook} {
    padding: 50px 440px 14px 80px;
    height: ${FooterSizes.notebook.height};
  }

  @media ${Media.desktop} {
    padding: 50px 150px 10px 150px;
    height: ${FooterSizes.desktop.height};
  }

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }
`;

export const FooterTopWrap = styled.div`
  @media ${Media.tablet} {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-height: 98px;
    align-content: flex-start;
  }
`;

export const FooterBottomWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  @media ${Media.desktop} {
    flex-direction: row-reverse;
    align-items: center;
  }
`;

export const LogoWrap = styled.div`
  margin-bottom: 20px;
  max-width: max-content;
`;

export const TextWrap = styled.div`
  margin-bottom: 31px;

  @media ${Media.tablet} {
    max-width: 248px;
    margin-bottom: 0px;
    margin-right: 88px;
  }

  @media ${Media.notebook} {
    max-width: 331px;
    margin-right: 55px;
  }

  @media ${Media.desktop} {
    max-width: 331px;
    margin-right: 87px;
  }
`;

export const PrivacyPolicyWrap = styled.div`
  margin-bottom: 19px;

  @media ${Media.desktop} {
    margin-bottom: 0px;
    margin-left: 18px;
  }
`;

export const LinkWrap = styled.div`
  margin-bottom: 30px;
  margin-right: 87px;

  @media ${Media.notebook} {
    margin-right: 81px;
  }
`;

export const Title = styled(Text)`
  display: none;

  @media ${Media.notebook} {
    display: block;
    padding-bottom: 20px;
  }
`;
